import { defineComponent, PropType } from 'vue'
import gsap from 'gsap'
import './index.scss'

const normalizeDisplayNumber = (value: number) => Math.max(0, Math.floor(value || 0))
const formatDisplayNumber = (value: number) =>
  normalizeDisplayNumber(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export default defineComponent({
  name: 'PreregisterCountDisplay',
  props: {
    value: {
      type: Number,
      default: 0
    },
    countDescription: String,
    className: null as unknown as PropType<unknown>
  },
  setup(props) {
    const displayValue = ref(normalizeDisplayNumber(props.value))
    let tween: gsap.core.Tween | null = null

    const updateValue = (targetValue: number) => {
      const target = normalizeDisplayNumber(targetValue)

      tween?.kill()

      if (target <= displayValue.value) {
        displayValue.value = target
        return
      }

      const counter = {
        value: displayValue.value
      }

      tween = gsap.to(counter, {
        value: target,
        duration: 1.2,
        ease: 'power2.out',
        onUpdate: () => {
          displayValue.value = Math.floor(counter.value)
        },
        onComplete: () => {
          displayValue.value = target
        }
      })
    }

    watch(
      () => props.value,
      (value) => {
        updateValue(value)
      }
    )

    onUnmounted(() => {
      tween?.kill()
    })

    return () => (
      <div class={['module-preregister-count-display', props.className]} aria-live="polite">
        <span class="module-preregister-count-display-text">{formatDisplayNumber(displayValue.value)}</span>
        {props.countDescription && <span class="module-preregister-count-display-label">{props.countDescription}</span>}
      </div>
    )
  }
})
